import React from "react";
import { Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { ACTIONS_DROPDOWN_PROPS } from "@/constants/actionsDropdown";
import { getFormOrganizationDisplayName, getFormOrganizationLogoUrl } from "@/utils/formTabs";
import { OrganizationsIcon } from "@/assets/svgs/icons";
import { getStatusColor, getStatusDisplayText } from "@/utils";

const FormCard = ({
  data,
  userRole,
  isDemoTab = false,
  onRowClick,
  getActionsMenuItems,
  onActionMenuClick,
}) => {
  const logoUrl = getFormOrganizationLogoUrl(data);
  const organizationName = getFormOrganizationDisplayName(data);

  return (
  <div
    className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-shadow cursor-pointer border"
    onClick={() => onRowClick(data)}
  >
    <div className="flex items-center gap-3 mb-3">
      <div className="relative flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-50">
        {!logoUrl && <OrganizationsIcon />}
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={organizationName || "Organisation logo"}
            className="h-full w-full object-cover"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        ) : null}
      </div>
      <span className="min-w-0 truncate font-medium text-gray-900">
        {organizationName || "N/A"}
      </span>
    </div>
    <div className="mb-3">
      <h3 className="font-medium text-gray-900 mb-2 mt-0">{data?.title}</h3>
      <p className="text-sm text-gray-500 mb-2 line-clamp-2">
        {data?.description?.trim() || "-"}
      </p>
      {!isDemoTab && (
        <span
          className="inline-flex px-3 py-1 rounded-full text-xs border text-black capitalize"
          style={{ border: "1px solid #000" }}
        >
          {data?.type}
        </span>
      )}
    </div>
    <div className="flex items-center justify-between flex-wrap gap-2">
      <span
        className={`inline-flex px-3 py-1 rounded-full text-sm capitalize ${getStatusColor(
          data.status,
        )}`}
      >
        {getStatusDisplayText(data.status)}
      </span>
      {userRole === "admin" && (
        <Dropdown
          {...ACTIONS_DROPDOWN_PROPS}
          menu={{
            items: getActionsMenuItems(data),
            onClick: (event) => onActionMenuClick(data, event.key, event),
          }}
        >
          <button
            type="button"
            className="actions-dots-btn"
            onClick={(e) => e.stopPropagation()}
            aria-label={`Open actions for ${data?.title || "form"}`}
          >
            <MoreOutlined />
          </button>
        </Dropdown>
      )}
    </div>
  </div>
  );
};

export default FormCard;
